import './archisingle.css';
import Footer from '../../components/footer/Footer';
import { useLocation } from "react-router";
import { archiData } from '../../data';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import SwiperCore, {
    Zoom,Pagination,Keyboard, Autoplay, EffectFade 
    } from 'swiper';

SwiperCore.use([Zoom,Pagination,Keyboard,Autoplay,EffectFade]);



export default function ArchiSingle() {
    const location = useLocation();
    const id = location.pathname.split('/')[2];

    return (
        <>
        <div className="archiSingle">
            <div className="viewWrapper">
                    <Swiper
                    zoom={{"maxRatio": 5}}
                    spaceBetween={0} 
                    effect={'fade'} 
                    pagination={{ "clickable": true}}
                    autoplay={{"delay": 3000, "disableOnInteraction": false}}
                    className="archiSingle__slider"
                    >
                        {archiData[id].slideImgs?.map((d) => (
                            <SwiperSlide  className="view">
                                <img src={d} alt={d.title} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    
                    <div className="view__description">
                        <div className="description__wrapper">
                                <h2>{archiData[id].title}</h2>
                                <h3>{archiData[id].location}</h3>
                                <div className="view__paragraph">
                                    <p>{archiData[id].summary}</p>
                                </div>
                        </div>
                    </div>
            </div>
        </div>
        <Footer />
        </>
    )
}
